import React, {useEffect, useState} from "react";
import figure1 from "../../../../assets/images/blog8-1.png";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import figure2 from "../../../../assets/images/blog8-2.jpeg";
import figure3 from "../../../../assets/images/newImage.png";
import figure4 from "../../../../assets/images/blog8-4.jpeg";
import figure5 from "../../../../assets/images/blog8-5.png";
import figure6 from "../../../../assets/images/blog8-6.png";
import figure7 from "../../../../assets/images/blog8-7.png";
import figure8 from "../../../../assets/images/blog8-8.png";
import figure9 from "../../../../assets/images/blog8-9.png";
import BlogImagePopper from "./BlogImageLarge";

const Blog8 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook March 3, 2025</h2>
      </div>
      <div className="blogContentnew">
        <div className="subHeader">
          <p className="highlightedBoldText">Setting the Stage: Markets React to Policy Shifts & Economic Cooling</p>
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p>
                As Q1 unfolds, market volatility is picking up, driven by weakening economic data and shifting policy expectations. The latest{" "}
                <span className="highlightedText">AtlantaFed GDPNow estimate</span> plummeted to <span className="highlightedText">(-1.5%) </span>from a high of{" "}
                <span className="highlightedText">3.9% </span>just weeks ago, signalling a sharp economic slowdown. This shift has traders recalibrating rate-cut expectations, with the Fed’s dual
                mandate—employment and inflation—returning to focus.
              </p>
              <p>
                The major indices are at key technical levels, with dip buyers on edge. <span className="highlightedText">The Nasdaq 100 (NAS100)</span> is testing the{" "}
                <span className="highlightedText">200-day moving average (DMA) </span>after a <span className="highlightedText">10% pullback</span>, raising the question: has the low already been set,
                or is a deeper correction looming?
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={figure1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <p className="highlightedBoldText">Key Market Themes </p>

          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">U.S. Economic Slowdown: Recession on the Horizon?</p>
              <p>
                The collapse in
                <span className="highlightedText"> consumer confidence</span>and
                <span className="highlightedText">weak retail sales</span> are setting up a stagflation narrative. If GDP trends are negative in Q1, the Fed may have no choice but to accelerate rate
                cuts.
                <span className="highlightedText"> Will Powell hold the line, or will political pressure push the Fed to act sooner?</span>
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={figure2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <p className="highlightedText_header">Bond Market Signals: Rate Cuts Incoming?</p>
              <p>
                Bond markets are pricing in
                <span className="highlightedText"> n 3-4 rate cuts </span> in 2025, with the US10Y yield now
                <span className="highlightedText"> grinding lower</span>However, inflation data remains
                <span className="highlightedText"> sticky </span>, creating a push-pull dynamic that could keep the Fed cautious.
                <span className="highlightedText"> Keep an eye on the yield curve and real rates—any steepening could signal recession fears taking over.</span>
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={figure3}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure3)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">Equity Markets: Dip-Buying or Breakdown?</p>

              <p>
                Major indices have pulled back, with the
                <span className="highlightedText"> S&P 500 holding key support,</span> while
                <span className="highlightedText"> small caps (Russell 2000) continue to struggle.</span> Hedge fund positioning shows a
                <span className="highlightedText"> rotation out of the “Magnificent 7” into equal-weight indices. </span>
                Is this the early sign of a<span className="highlightedText">broader correction </span>or a sectoral reset?
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={figure4}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure4)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Global Macro Shifts: Europe & China</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Europe’s Peace Dividend?</h2>
                  <p>
                    Poland is outperforming as rebuilding efforts post-Ukraine truce pick up steam. However, with <span className="highlightedText">Trump threatening 25% tariffs on EU imports,</span>{" "}
                    European markets could soon face headwinds.
                  </p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> China Stimulus Watch:</h2>
                  <p>
                    The<span className="highlightedText"> National People's Congress (March 6)</span> could unveil fresh fiscal stimulus. Markets will react sharply to any signs of economic lifelines
                    being extended.
                  </p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={figure5}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure5)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Analysis</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Equities</h2>
                  <p>: Holding key levels, but sentiment remains fragile.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Bonds</h2>
                  <p>:Rate cut expectations rising, yet inflation remains a concern.</p>
                </li>

                <li className="themesPointer">
                  <h2 className="pointersText"> Commodities</h2>
                  <p>
                    : Gold testing <span className="highlightedText">ATHs</span>, oil facing supply-demand uncertainties.
                  </p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Crypto</h2>
                  <p>: Bitcoin rebounded on Trump’s crypto reserve comments—will it sustain?</p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={figure6}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure6)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Key Events & Earnings</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">AtlantaFed GDPNow Collapses</h2>
                  <p>: Real-time GDP estimates show Q1 contraction.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Trump’s Tariff Threats</h2>
                  <p>
                    : 25% tariffs on<span className="highlightedText"> EU autos and other goods</span>—a major escalation in trade tensions.
                  </p>
                </li>

                <li className="themesPointer">
                  <h2 className="pointersText"> Hedge Funds Dumping Big Tech</h2>
                  <p>: Mag7 seeing sharp outflows as institutions rotate into equal-weight strategies.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Nvidia Sell-Off</h2>
                  <p>
                    : <span className="highlightedText">Biggest post-earnings drop in a year </span>despite strong numbers, reflecting a shift in market sentiment.
                  </p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={figure7}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure7)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Market Events</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText"> Monday ( March 3): Global Manufacturing PMIs and ISM Manu plus EZ CPI -</h2>
                  <p>key drivers for rate cuts historically</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Tuesday (March 4): BOJ chief Ueda updates -</h2>
                  <p>Yen seems a one way bet?</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Wednesday (March 5): China National People’s Congress –</h2>
                  <p>Will the stimulus be enough to match the rally so far?</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Global services PMIs and U.S. ISM Services PMI –</h2>
                  <p>A key indicator of economic resilience.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Thursday (March 6): ECB Rate Decision –</h2>
                  <p>Enough concerns for 25bp this week, but will they go big and cut 50bp instead?</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Friday (March 7): U.S. Jobs Report (NFP) –</h2>
                  <p>A pivotal report for Fed rate expectations with Powell speaking later in the day</p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={figure8}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure8)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Actionable Takeaways</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText"> Rates & Recession Risks:</h2>
                  <p>If data continues to weaken, the Fed will be under pressure to cut faster—watch bond yield movements.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Equity Market Inflection:</h2>
                  <p>The next move hinges on upcoming economic reports and Powell’s response.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Gold & Safe Havens:</h2>
                  <p>Gold is on the verge of another breakout—geopolitical risks could accelerate this move.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Crypto’s Wildcard:</h2>
                  <p>Trump’s comments reignited speculation—will regulatory clarity push Bitcoin higher?</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Key Trades to Watch</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText"> Long Gold:</h2>
                  <p>If inflation fears persist and central banks remain dovish, gold could see another rally.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Short Small Caps (IWM):</h2>
                  <p>The Russell 2000 is lagging—momentum remains weak.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Watch EUR/USD:</h2>
                  <p>Trade war rhetoric and ECB decisions could drive volatility</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Bitcoin Upside?:</h2>
                  <p>If the “Trump Crypto Reserve” narrative gains traction, BTC could push higher.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <h2 className="highlightedText">Markets are in a fragile state—position wisely and stay nimble.</h2>
              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={figure9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => setSelectedImage(figure9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1s9ijgyPRsmvzzgsuadbjeLfMhStNONeDOBp2NOjYJ6s/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog8;
